exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.plugin-video[data-v-88e7e564] {\n  width: 679px;\n  max-width: 100%;\n}\n", ""]);

// exports
